export default "__VITE_ASSET__719c47df__"